export function mapLiveWatchError(
  code: string | null | undefined,
  t: (key: string) => string,
): string | null {
  if (!code) return null;

  const key = `admin.liveWatches.errors.${code}`;
  const mapped = t(key);
  return mapped === key ? t("admin.liveWatches.fields.lastError") : mapped;
}
